import { ICustomerCustomField } from "modules/order/domain/models/ICustomer";

const SEPARATOR = " | ";

const capitalize = (text: string) =>
  text.length ? text.charAt(0).toLocaleUpperCase() + text.slice(1) : text;

/**
 * Campos de identificação configurados no local que não têm destino próprio no
 * pedido (ex.: "pager") seguem na observação do pedido como "Label: valor",
 * depois da observação que o cliente já tiver escrito.
 */
export const appendCustomerFieldsToObservation = (
  observation: string | undefined,
  customFields: ICustomerCustomField[] | undefined
): string | undefined => {
  const fields = (customFields ?? [])
    .filter((it) => it.value?.trim())
    .map((it) => `${capitalize(it.label.trim())}: ${it.value.trim()}`);

  if (!fields.length) {
    return observation;
  }

  return [observation?.trim(), ...fields].filter(Boolean).join(SEPARATOR);
};
